import { Box, Typography } from '@mui/material';
import React from 'react';

const MustPickArtist: React.FC = () => {
  return (
    <Box>
      <Typography variant='body2'>
        You must pick an artist before making changes
      </Typography>
    </Box>
  );
};

export default MustPickArtist;
